export default __webpack_public_path__ + "static/media/lista_wizard.5075a216.png";